import { useMemo } from 'react';
import { UserRankingDto } from '@repo/shared/dtos/analytics/UtilizationDto';
import { isChampion, isPowerMember, isInactive } from '../utils/tierUtils';
import type { MemberFilter } from '../top-users-modal/MemberFilterTabs';

export function useFilteredMembers(users: UserRankingDto[], activeFilter: MemberFilter) {
  return useMemo(() => {
    const championList: typeof users = [];
    const power: typeof users = [];
    const atRisk: typeof users = [];

    for (const user of users) {
      if (isChampion(user)) championList.push(user);
      else if (isPowerMember(user)) power.push(user);
      else if (isInactive(user)) atRisk.push(user);
    }

    let byTab: typeof users;
    if (activeFilter === 'champion') byTab = championList;
    else if (activeFilter === 'power') byTab = power;
    else if (activeFilter === 'inactive') byTab = atRisk;
    else byTab = users;

    return {
      allUsers: users,
      champions: championList,
      powerUsers: power,
      atRiskUsers: atRisk,
      filteredByTab: byTab,
    };
  }, [users, activeFilter]);
}
